export default __webpack_public_path__ + "static/media/task_overdue.650e9934.svg";